import BigNumber from 'bignumber.js';

const digits = '۰۱۲۳۴۵۶۷۸۹';
export const persianDigits = (value: string) => value.replace(/\d/g, (digit) => digits[Number(digit)]);

export function number(value: string | number | null | undefined, precision = 2): string {
  if (value === null || value === undefined || value === '') return '—';
  const parsed = new BigNumber(value);
  if (!parsed.isFinite()) return '—';
  return persianDigits(
    parsed
      .toFormat(precision)
      .replace(/\.0+$|(?<=\.\d*)0+$/g, '')
      .replace(/\.$/, ''),
  );
}

export function balance(value: string | null | undefined, decimals = 18): string {
  if (value === null || value === undefined || value === '') return '—';
  return number(new BigNumber(value).shiftedBy(-decimals).toFixed(), 6);
}

export function percentage(value: string | null, supply: string | undefined, decimals = 18): string {
  if (!value || !supply || !new BigNumber(supply).isGreaterThan(0)) return '—';
  return number(new BigNumber(value).shiftedBy(-decimals).div(supply).times(100).toFixed(), 8) + '٪';
}

export const shortHash = (hash: string) => `${ hash.slice(0, 8) }…${ hash.slice(-6) }`;

export function dateTime(value: string | null | undefined, withSeconds = false): string {
  if (!value || !Number.isFinite(Date.parse(value))) return '—';
  return new Intl.DateTimeFormat('fa-IR', { dateStyle: 'short', timeStyle: withSeconds ? 'medium' : 'short', timeZone: 'Asia/Tehran' }).format(
    new Date(value),
  );
}

export function normalizeSearch(value: string): string {
  return value
    .trim()
    .replace(/[\u06f0-\u06f9]/g, (digit) => String(digits.indexOf(digit)))
    .replace(/[\u0660-\u0669]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
}

// Older Blockscout backends return a number; newer versions return { price }.
export function gasPrice(value: unknown): string {
  if (typeof value === 'number') return number(value, 4);
  if (value && typeof value === 'object' && 'price' in value && typeof value.price === 'number') return number(value.price, 4);
  return '—';
}

export function relativeTime(value: string | undefined, reference: string | undefined): string {
  if (!value || !reference) return '—';
  const elapsed = (Date.parse(value) - Date.parse(reference)) / 1000;
  if (!Number.isFinite(elapsed)) return '—';
  const formatter = new Intl.RelativeTimeFormat('fa-IR', { numeric: 'always' });
  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    [ 'year', 365 * 86400 ],
    [ 'month', 30 * 86400 ],
    [ 'day', 86400 ],
    [ 'hour', 3600 ],
    [ 'minute', 60 ],
  ];
  const unit = units.find(([ , seconds ]) => Math.abs(elapsed) >= seconds);
  if (!unit) return 'همین حالا';
  return formatter.format(Math.trunc(elapsed / unit[1]), unit[0]);
}
